module.exports = __webpack_public_path__ + "static/media/CICLO_5_PAZ_Y_COMUNIDAD_DIGITAL_2022.f1a49d71.jpg";